import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=cc70436c&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc70436c')) {
      api.createRecord('cc70436c', component.options)
    } else {
      api.reload('cc70436c', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=cc70436c&", function () {
      api.rerender('cc70436c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28PNoMckAly2U/JS/offershelp.vue"
export default component.exports